/* ══════════════════════════════════════════════════════════════════════
   普通页面的两件小事。设计稿：新一版设计/page-layout-preview.html

     1. 给每张表套一层横滑外壳 —— 富文本编辑器出不来这个壳，
        而**没有它，窄屏上一张运费表会把整页撑出横向滚动条**。
     2. 从正文里的 h2 生成目录 —— 让运营维护第二份目录，
        结局一定是改了正文忘了目录。

   两件都只在**真的需要**的时候才做：没有表就不套壳，
   小标题不够多就不出目录。
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.ebPageLoaded) return;
  window.ebPageLoaded = true;

  /* 从标题文字造锚点 id。已经有 id 的（法务原文里带的）不动。 */
  function slug(text, used) {
    var base = String(text || '')
      .toLowerCase()
      .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
    var id = base, i = 2;
    while (used[id]) { id = base + '-' + i; i += 1; }
    used[id] = true;
    return id;
  }

  function enhance(root) {
    var rte = root.querySelector('[data-page-rte]');
    if (!rte) return;

    /* ── 1. 表格外壳 ── */
    Array.prototype.forEach.call(rte.querySelectorAll('table'), function (t) {
      if (t.parentNode && t.parentNode.classList.contains('eb-tablewrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'eb-tablewrap';
      /* 能滑的东西要能用键盘滑到 —— 否则只有鼠标用户看得到右边那几列 */
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      var cap = t.querySelector('caption');
      wrap.setAttribute('aria-label', cap ? cap.textContent.trim() : (t.dataset.label || 'Table'));
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });

    /* ── 2. 目录 ── */
    var slot = root.querySelector('[data-page-toc]');
    if (!slot) return;
    var min = parseInt(slot.dataset.min, 10) || 4;
    var heads = rte.querySelectorAll('h2');
    if (heads.length < min) return;

    var used = {};
    Array.prototype.forEach.call(rte.querySelectorAll('[id]'), function (el) { used[el.id] = true; });

    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(heads, function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      frag.appendChild(a);
    });
    slot.appendChild(frag);
    slot.hidden = false;
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-page]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
